import React from "react";
import PreviewBuilder from "./PreviewBuilder";

const BuilderPreviewList = ({ builderPreview, setShowPreview }) => {
  return (
    <React.Fragment>
      <div
        className="bg-white container ps-0"
        style={{
          top: "60px",
          width: "34%",
          right: "-25px",
          bottom: "0px",
          overflowY: "scroll",
          position: "fixed",
          boxShadow: "0 2px 4px 0 rgba(116, 116, 116, 0.15)",
        }}
      >
        <div className="">
          <div
            className="border-bottom d-flex justify-content-between pe-3 ps-3"
            style={{
              height: "65px",
            }}
          >
            <span className="align-self-center fs-5 fw-bold mb-0 pt-2">
            Product Preview
            </span>
            <button
              data-testid="builder-preview-list-close-btn"
              aria-label="Close"
              className="align-self-center border-0 btn fw fw-light mb-1 me-1 shadow-none"
              onClick={() => {
                return setShowPreview(false);
              }}
            >
              X
            </button>
          </div>
        </div>
        <div className="p-3">
          <div className="accordion" id="accordionPanelsStayOpenExample">
            {builderPreview &&
              builderPreview.map((item, index) => {
                return (
                  <PreviewBuilder
                    previewComponent={item}
                    index={index}
                    key={index}
                  />
                );
              })}
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};
export default BuilderPreviewList;
